'use client';
import {cn} from '@/lib/utils';
import parse from 'html-react-parser';
import Link from 'next/link';
import Script from 'next/script';
import {useEffect, useState} from 'react';

export default function MilestonesPage(Prop: {
  moduleData: any;
  moduleOption: any;
}) {
  const [screenSize, setScreenSize] = useState(1000);
  const yearGroups = Prop?.moduleOption?.yearGroup || [1828, 1900, 1980, 2000];

  const milestoneItems: {
    year: number;
    events: any[];
  }[] = [];

  Prop.moduleData.map((item: any) => {
    const year = parseInt(item.title.substring(0, 4));
    let yearGroup = yearGroups[0];
    yearGroups.map((group: number) => {
      if (year >= group) {
        yearGroup = group;
      }
    });
    if (!milestoneItems[yearGroup]) {
      milestoneItems[yearGroup] = {
        year: yearGroup,
        events: []
      };
    }
    milestoneItems[yearGroup].events.push(item);
  });

  const customStyle = `
  .timeline__content:after, .timeline__content:before {
    border-left-color: #f5f5f5 !important;
  }
  .timeline__item--right .timeline__content:after, .timeline__item--right .timeline__content:before {
    border-right-color: #f5f5f5 !important;
  }`;

  let observerTimeline = setTimeout(() => {}, 100);

  useEffect(() => {
    setScreenSize(window.innerWidth);
    if (observerTimeline) clearTimeout(observerTimeline);
    observerTimeline = setTimeout(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.remove('opacity-0');
              entry.target.classList.remove('translate-y-4');
            }, 100);
          }
        });
      });

      document.querySelectorAll('.observe').forEach(function (el) {
        observer.observe(el);
      });
    }, 100);

    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <div className="questrial text-[18px]">
      <div
        className={cn(
          'flex items-center justify-center  transition-opacity duration-500 ease-in-out divider divide-x divide-gray-200 my-10'
        )}
      >
        {yearGroups.map((year: number) => (
          <Link
            prefetch={false}
            key={year}
            href={`#group-${year}`}
            className="px-2 hover:text-[#e21736]"
          >
            {year}
          </Link>
        ))}
      </div>
      <Script src="/js/timeline.min.js"></Script>
      <style>{customStyle}</style>
      <link rel="stylesheet" href="/css/timeline.min.css" />
      <div
        className={cn(
          'flex flex-col gap-4 transition-opacity duration-500 ease-in-out'
        )}
      >
        {milestoneItems?.map((item: any, index: number) => (
          <div
            key={index}
            className={'flex flex-col gap-4 md:ml-0 ml-[-70vw]'}
            id={'group-' + item.year}
          >
            <div
              className="flex justify-center items-center mb-4 py-4"
              id={item.year}
            >
              <h2 className="text-2xl font-bold rounded-full aspect-square p-2 bg-[#e21736] flex items-center justify-center text-white">
                {item.year}
              </h2>
            </div>
            <div className="timeline" key={index}>
              <div className="timeline__wrap">
                <div className="timeline__items ">
                  {item.events.map((milestone: any, index: number) => {
                    return (
                      <div
                        key={'events' + index}
                        className={cn(
                          'timeline__item observe transition-all duration-500 ease-in-out opacity-0 translate-y-4 ',
                          index % 2 === 0 && screenSize > 768
                            ? 'timeline__item--left'
                            : 'timeline__item--right'
                        )}
                      >
                        <div
                          id={'item-' + milestone.title}
                          className="border-0 timeline__content bg-gray-100 rounded-lg  p-4 "
                          style={{
                            background: '#f5f5f5',
                            border: 'none'
                          }}
                        >
                          <div className="text-3xl mb-2 font-[700]">
                            {milestone.title}
                          </div>
                          <div>
                            {(milestone?.events ?? [])
                              .filter((a: any) => a.content)
                              .map(
                                (
                                  event: {content: string; image?: string},
                                  i: number
                                ) => {
                                  return (
                                    <div
                                      className="mb-5"
                                      key={'event_' + milestone.title + '_' + i}
                                    >
                                      {event.image && (
                                        <img
                                          src={event.image}
                                          alt={milestone.title}
                                          className={cn('w-full')}
                                        />
                                      )}
                                      <div className="leading-relaxed">
                                        {parse(event.content)}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
